// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__3vHSA","Input":"Auth_Input__3RsHn"};